<template>
  <div id="app">
    <router-view v-if="alive" />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import {setWatchInterval} from '@/utils/auth'
export default {
  name: 'App',
  components: {},
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      alive: true
    }
  },
  computed: {
    ...mapGetters(['siteName','isLogin','crrInterval'])
  },

  created() {
    this.initSite()
    if(this.isLogin){
      this.doRefreshToken()
    }
  },
  mounted() {
    window.addEventListener('visibilitychange',this.needRefreshToken)
  },
  methods: {
    ...mapActions({
      initSite: 'app/initSite',
      doRefreshToken : 'user/doRefreshToken',
      needRefreshToken: 'user/needRefreshToken'
    }),
    reload() {
      this.alive = false
      this.$nextTick(() => {
        this.alive = true
      })
    },
  },
  destroyed(){
    window.removeEventListener('visibilitychange',this.needRefreshToken)
  }
}
</script>

<style lang="scss" >
// html{
//   filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
//     -webkit-filter: grayscale(100%);
// }

#app {
  height: 100%;
}
body,
html {
  height: 100%;
  font-family: Microsoft YaHei;
}
.disabled_btn {
  cursor: no-drop !important;
  background-color: rgba($color: #0983cc, $alpha: 0.5) !important;
}

body .el-menu--popup .float_l {
  float: none;
}

.block_title_w {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 43px 0 0 0;
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 6px;
    height: 20px;
    background: url("./assets/images/project_point.png") 100% 100% no-repeat;
  }
  .l_title {
    margin: 0 0 0 15px;
    font-size: 22px;

    font-weight: 400;
    color: #141414;
  }
  .right {
    display: inline-flex;
    .r_title {
      margin: 0 5px 0 0;
      font-size: 14px;

      font-weight: 400;
      color: #8c481f;
    }
    img {
      width: 12px;
      height: 12px;
    }
  }
}
</style>
